<template>
  <div class="msg" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div>
      <el-row :gutter="10">
        <el-col :span="24">
          <h3 style="margin: 0; background-color: #666; padding: 3px; color: #fff; font-weight: 600;">交易推播訊息</h3>
          <!-- 第一頁推播訊息 -->
          <div v-if="nowPage === 1">
            <div class="textarea" v-for="(item, index) in allMsgs.slice(0, 3)" :key="index">
              <span style="margin-right: 10px; color: black; font-weight: 500;">{{ item.title }}</span>
              <div style="transform: scale(0.8); display: inline-block; margin-bottom: 10px;">
                <el-switch v-model="item.open"
                  :width="45"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </div>
              <el-input type="textarea"
                v-if="item.open"
                autosize
                placeholder="請輸入內容"
                v-model="item.text">
              </el-input>
              <div v-if="item.open" style="font-size: 12px; margin-top: 5px; text-align: right; white-space: pre-line;">{{ item.hint }}</div><hr/>
            </div>
          </div>
          <!-- 第二頁推播訊息 -->
          <div v-if="nowPage === 2">
            <div class="textarea" v-for="(item, index) in allMsgs.slice(3, 6)" :key="index">
              <span style="margin-right: 10px; color: black; font-weight: 500;">{{ item.title }}</span>
              <div style="transform: scale(0.8); display: inline-block; margin-bottom: 10px;">
                <el-switch v-model="item.open"
                  :width="45"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </div>
              <el-input type="textarea"
                v-if="item.open"
                autosize
                placeholder="請輸入內容"
                v-model="item.text">
              </el-input>
              <div v-if="item.open" style="font-size: 12px; margin-top: 5px; text-align: right; white-space: pre-line;">{{ item.hint }}</div><hr/>
            </div>
          </div>
          <!-- 送出按鈕 -->
          <el-pagination background
            @current-change="getVal"
            layout="prev, pager, next"
            :total="20">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
    <div style="text-align: center; margin-top: 20px;">
      <mu-button color="primary"
        style="margin-top: 0px; width: 100%;"
        @click="sendMsg">送出
      </mu-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  name: 'broadcastRecord',
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      nowPage: 1,
      pageLoading: false,
      allMsgs: []
    }
  },
  props: ['AllMsg'],
  mounted() {
    this.allMsgs = this.AllMsg;
  },
  methods: {
    ...mapActions({
      setSuccessMessage: 'setSuccessMessage'
    }),
    showFlassMessage(message, time) {
      this.$notify({
        title: message,
        type: 'success'
      });
    },
    getVal(val) {
      this.nowPage = val;
    },
    sendMsg() {
      this.pageLoading = true;
      const msgPromise = this.allMsgs.map((el, idx) => this.setSuccessMessage({
        service: this.service,
        auth: this.auth,
        type: el.type,
        msg: el.open ? el.text : 'null'
      }));
      return Promise.all([...msgPromise]).then(() => {
        this.pageLoading = false;
        this.showFlassMessage('已完成設定', 2000);
      });
    }
  },
}
</script>

<style scoped>
.textarea {
  text-align: left;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  border-radius: 7px;
}
.msg {
  margin: 0 auto;
  background-color: #fff;
  padding: 15px;
  border-radius: 5px;
  width: 89%;
  /* min-width: 750px; */
  width: 850px;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
}
.layout {
  min-width: 100%;
  max-width: 100%;
  margin-left: 0!important;
  flex: 1 1 100%;
  padding: 30px;
}
</style>